import React, { useState } from 'react';
import { auth } from '../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Link } from 'react-router-dom';
import './Auth.css';

const ResetPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);

    const handleReset = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await sendPasswordResetEmail(auth, email);
            setSent(true);
        } catch (error: any) {
            alert(error.message);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-box">
                <h2>Reset Password</h2>
                <p style={{ fontSize: '0.97em', color: '#555', marginBottom: 16 }}>
                    Enter your email address below. If the email exists, you will receive a reset email.
                </p>
                {sent ? (
                    <div>
                        <p style={{ color: 'green' }}>A password reset email has been sent to your email address.</p>
                        <Link to="/login">Back to Login</Link>
                    </div>
                ) : (
                    <form onSubmit={handleReset}>
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                        <button type="submit">Send Reset Email</button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ResetPassword;